import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Input } from 'reactstrap';
import { addModal } from '../../../actions/modals';
import store from '../../../store';
import { toHHMMSS } from '../../../utils/helper';

const getPreview = ({ intl, type, file_link, original_name, note_text }) => {
  const mType = note_text ? 'shared_note' : type;

  switch (mType) {
    case 'image':
    case 'shared_image':
      return (
        <img
          src={file_link}
          alt={original_name || ''}
          style={{ maxWidth: '100%', maxHeight: 480 }}
        />
      );
    case 'video':
      return (
        <video width="100%" preload="metadata" controls>
          <source src={file_link} type="video/mp4" />
          <track kind="captions" label={original_name || ''} />
        </video>
      );
    case 'audio':
      return (
        <audio style={{ width: '100%' }} preload="metadata" controls>
          <source src={file_link} type="audio/mpeg" />
          <track kind="captions" label={original_name || ''} />
        </audio>
      );
    case 'shared_note':
      return <Input type="textarea" rows="9" value={note_text} />;
    default:
      return intl.formatMessage({ id: 'messages_preview_isNotAvailable' });
  }
};

getPreview.propTypes = {
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
  type: PropTypes.string.isRequired,
  file_link: PropTypes.string.isRequired,
  original_name: PropTypes.string,
};

const GetPreview = injectIntl(getPreview);

const ModalPreview = ({
  type,
  description,
  file_link,
  original_name,
  size,
  duration,
  note_text,
}) =>
  store.dispatch(addModal(
    1,
    [
      <React.Fragment>
        <p>{description || ''}</p>
        <p style={{ textAlign: 'center' }}>
          <GetPreview {...{ type, file_link, original_name, note_text }} />
        </p>
        <p>
          {size &&
              ['document', 'image', 'video', 'audio'].includes(type) &&
              `${Math.round((size * 100) / 1024 / 1024) / 100} Mb`}
          {duration &&
              ['video', 'audio'].includes(type) &&
              ` / ${toHHMMSS(duration)}`}
        </p>
      </React.Fragment>,
    ],
    original_name,
    file_link,
  ));

ModalPreview.propTypes = {
  message: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default ModalPreview;



// WEBPACK FOOTER //
// ./src/views/_Chats/Messages/ModalPreview.js